import HttpClient from "../../HttpClient";
import apiRoutes from "../../Routes/Routes.json";

const routes = apiRoutes.Payment;

export const GetPaymentStatus = (
  paymentAttemptId: string,
  sessionId: string,
  supplyOrderId?: string
) => {
  return HttpClient().get(`/${routes.GetPaymentStatus}`, {
    params: {
      paymentAttemptId,
      sessionId,
      supplyOrderId,
    },
  });
};

export const ReinitiatePayment = (pageReferenceUniqueId: number) => {
  return HttpClient().post(
    `/${routes.ReinitiatePayment}?PageReferenceUniqueId=${pageReferenceUniqueId}`
  );
};

export const extractReceiptUrl = (payload: unknown): string => {
  if (!payload || typeof payload !== "object") return "";

  const body = payload as Record<string, unknown>;
  const nested =
    body.data && typeof body.data === "object"
      ? (body.data as Record<string, unknown>)
      : null;

  const receiptUrl = nested?.receiptUrl ?? body.receiptUrl;
  return typeof receiptUrl === "string" ? receiptUrl.trim() : "";
};

const PaymentService = {
  GetPaymentStatus,
  ReinitiatePayment,
};

export default PaymentService;
